// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ReversePeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/reverse_period/{id}
 *
 * Returns a success flag after reversing a paid period.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ReversePeriodResponseDados = boolean;

export type Payroll_ReversePeriodResponse = ApiResponse<Payroll_ReversePeriodResponseDados>;

registerResponseContract('Payroll_ReversePeriodResponse', {})
